












import { Component, Vue } from 'vue-property-decorator';
import { Pagination } from '@/components/form';
import PaymentUserSearch from './search.vue';
import PaymentUserAction from './action.vue';
import PaymentUserTable from './table.vue';

import { Getter } from 'vuex-class';
import { Now, Season, Month } from '@/domains/date';
import { Supervisor, SupervisorGroup } from '@/domains/supervisor';
import { Load } from '@/domains/system';
import { Page } from '@/domains/page';
import { Record, Plan } from '@/domains/work';
import { Person } from '@/domains/person';
import { PaymentRecord, Payment, PaymentStatus } from '@/domains/payment';
import { CoursePlanExec, CoursePlan } from '@/domains/course';

@Component({
  name: 'PaymentUserPage',
  components: {
    PaymentUserSearch,
    PaymentUserAction,
    PaymentUserTable,
    Pagination,
  },
})
export default class PaymentUserPage extends Vue {
  @Getter private now: Now;

  @Getter private supervisor: Supervisor;

  /** 加载 */
  private load: Load = new Load();

  /** 表单 */
  private form: PaymentRecord = new PaymentRecord();

  /** bus */
  private bus: Vue = new Vue();

  /** 初始化表单 */
  private initForm(): void {
    const form: PaymentRecord = new PaymentRecord();
    const payment: Payment = new Payment();
    const paymentStatus: PaymentStatus = new PaymentStatus();
    const month: Month = new Month();
    const season: Season = new Season();
    const record: Record = new Record();
    const plan: Plan = new Plan();
    const supervisor: Supervisor = new Supervisor();
    const person: Person = new Person();
    const coursePlan: CoursePlanExec = new CoursePlanExec();
    const clazz: CoursePlan = new CoursePlan();
    const page: Page = new Page();

    form.pay = payment;
    form.pageInfo = page;
    payment.month = month;
    payment.payStatus = paymentStatus;
    month.season = season;
    form.record = record;
    record.plan = plan;
    plan.supervisor = supervisor;
    supervisor.person = person;
    plan.coursePlan = coursePlan;
    coursePlan.clazz = clazz;

    paymentStatus.id = 1;
    person.id = this.supervisor.person.id;
    clazz.year = this.now.year.year;
    clazz.term = this.now.year.term;

    this.form = form;
  }

  private created() {
    this.initForm();
  }

  private mounted() {
    this.bus.$on('payment-user-initForm', () => { this.initForm(); });
    this.$nextTick(() => { this.bus.$emit('payment-user-search'); });
  }
}
